import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { DashboardCard, IDashboardCard } from '../../modals/dashboard-card.class';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss']
})
export class DashboardCardComponent implements OnInit {
  @Input() cardHeaderAction: TemplateRef<HTMLElement>;
  @Input() collapsedCardHeader: TemplateRef<HTMLElement>;
  @Input() cardHeader: TemplateRef<HTMLElement>;
  @Input() dashboardCard: DashboardCard = new DashboardCard({} as IDashboardCard);
  @Input() headerIcon: string;
  @Input() headerText: string;
  @Input() toggleable: true;
  @Input() transitionOptions: string;
  @Input() collapsedOnMobile = false;
    constructor() {
  }
  ngOnInit(): void {
    if (this.collapsedOnMobile) {
      if (window.innerWidth < 468) {
        this.dashboardCard.isCollapsed = true;
        }
    }
  }
  panelToggle() {
    this.dashboardCard.isCollapsed = !this.dashboardCard.isCollapsed;
  };
}
